






















































































import { Component, Vue, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import EventBus from '@/plugins/EventBus'
import RecebimentoStore from '@/components/Recebimento/Store/RecebimentoStore'
import _ from 'lodash'

@Component
export default class ModalAddProfissionaisEquipeMedica extends Vue {
  camposCadastrais: boolean = false
  searchProfissional: any = ''
  loadingProfissionalFilter: boolean = false
  profissionaisFromSearch: any[] = []

  $refs!: {
    formPrestador: any,
    imageUpload: any,
  }

  form: any = {
    valid: true,
    prestador: [(v: any) => !!v || 'Campo obrigatório'],
  }

  profissionaisDebounced = _.debounce(param => this.getRecebimentoStore.getProfissionais(param), 500)

  loadSaveAddGestor: boolean = false
  get loadingSaveAddGestor() { return this.loadSaveAddGestor }
  set loadingSaveAddGestor(value: boolean) { this.loadSaveAddGestor = value }

  get getRecebimentoStore() {
    return getModule(RecebimentoStore, this.$store)
  }

  get showModal() { return this.getRecebimentoStore.modalAddProfissional }
  set showModal(value: boolean) { this.getRecebimentoStore.setModalAddProfissional(value) }

  get profissionais() {
    const selected = this.selectedProfissional
    const fromSearch = this.profissionaisFromSearch
    
    const combined = [...selected]
    fromSearch.forEach(prof => {
      if (!combined.find(s => s.userId === prof.userId)) {
        combined.push(prof)
      }
    })
    
    return combined
  }
  
  get empresaMedicaList() { return this.getRecebimentoStore.prestadores }

  get selectedProfissional() { return this.getRecebimentoStore.selectedProfissional }
  set selectedProfissional(value: any) { this.getRecebimentoStore.setSelectedProfissional(value) }

  get selectedEmpresaMedica() { return this.getRecebimentoStore.selectedEmpresaMedica }
  set selectedEmpresaMedica(value: any) { this.getRecebimentoStore.setSelectedEmpresaMedica(value) }

  get profissionaisList() { return this.getRecebimentoStore.profissionais }

  async saveProfissionais() {
    this.loadingSaveAddGestor = true
    if (!(await this.$refs.formPrestador.validate())) {
      this.loadingSaveAddGestor = false
      return
    }
    
    const response = await this.getRecebimentoStore.upsertTabelaProfissionaisById()
    if (response.success) {
      EventBus.$emit('setSnackbar', { show: true, text: 'Prestador adicionado com sucesso!', icon: 'done', color: '#2E7D32' })
      await this.getRecebimentoStore.getProfissionaisEquipeMedica()
      this.showModal = false
    } else {
      EventBus.$emit('setSnackbar', { show: true, text: 'Erro ao adicionar prestador!', icon: 'warning', color: '#C62828' })
    }
    this.loadingSaveAddGestor = false
  }

  @Watch('searchProfissional')
  async onSearchProfissionalChanged(val: string) {
    if (!val || val.length < 3){
      return
    }
    
    this.loadingProfissionalFilter = true
    
    await this.profissionaisDebounced(val)
  }

  @Watch('showModal')
  onChangeShowModalEditarHospital(value: boolean) {
    if (!value) {
      this.$refs.formPrestador.resetValidation()
      this.$refs.formPrestador.reset()
      this.profissionaisFromSearch = []
    }
  }

  @Watch('profissionaisList')
  onChangeProfissionaisFromStore(value) {
    if (value) {
      this.profissionaisFromSearch = value
      this.loadingProfissionalFilter = false
    }
  }
}
